import { Inject, Injectable, OnInit, PLATFORM_ID, Signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment.development';
import { ResponseDefault } from '../../core/models/response-default';
import { isPlatformBrowser } from '@angular/common';
import { Store } from '@ngxs/store';
import { AuthState } from '../state/auth.state';
import { AuthActions } from '../state/auth.actions';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  // localStorage = document.defaultView?.localStorage;
  expired: Signal<number>;
  login: Signal<any>;
  constructor(
    private http: HttpClient,
    private store: Store,
  ) {
    this.expired = this.store.selectSignal(AuthState.getExpiry);
    this.login = this.store.selectSignal(AuthState.getAuth);
  }

  postCreateCode(body) {
    return this.http.post<ResponseDefault>(`${environment.api}auth/code`, body);
  }
  postValidate(body) {
    return this.http.post<ResponseDefault>(`${environment.api}auth/validate_code`, body);
  }
  setWithExpiry() {
    const now = new Date();
    this.store.dispatch(new AuthActions.Expiry());
  }
  getWithExpiry() {
    let validate;
    let test = this.store.select(AuthState.getAuth);

    if (!this.login()) {
      validate = false;
      // return false;
    } else {
      const now = new Date();
      if (now.getTime() > this.expired()) {
        this.store.dispatch(new AuthActions.Set({ expiry: 0, login: false }));
        validate = false;
        // return false;
      } else {
        validate = true;

        // return true;
      }
    }

    // await this.store.select(AuthState.getAuth).subscribe(res => {
    //
    //   if (!res.login) {
    //     validate = false;

    //   } else {
    //     const now = new Date();
    //     if (now.getTime() > res.expiry) {
    //       // this.store.dispatch(new AuthActions.Set({ expiry: 0, login: false }));
    //       validate = false;
    //     } else {
    //       validate = true;
    //     }

    //   }

    // });

    return validate;
  }
}
function initFlowbite() {
  throw new Error('Function not implemented.');
}
